class StoreLocator extends HTMLElement {
  constructor() {
    super();
    this.item = this.querySelectorAll('.item');
    this.map = this.querySelector('#map');

    if (this.item) this.item.forEach(item => {item.addEventListener('click', this.onButtonClick.bind(this))});
  }

  onButtonClick(event) {
    const target = event.currentTarget;
    const map = target.dataset.map;
    this.map.classList.add('map-loading');
    this.querySelector('.active').classList.remove('active');
    target.classList.add('active');
    setTimeout(() => {this.map.innerHTML = map}, 300);
    setTimeout(() => {this.map.classList.remove('map-loading')}, 1200);
  }
}
customElements.define('store-locator', StoreLocator);

document.addEventListener("DOMContentLoaded", function () {
  const allSections = Array.from(document.querySelectorAll('.section-find-a-store .store-locator'));
  const primarySection = allSections[0];

  function mergeLists(selector, keyFn) {
    const mainUl = primarySection.querySelector(selector);
    const existingKeys = new Set();

    mainUl.querySelectorAll('li').forEach(li => {
      existingKeys.add(keyFn(li));
    });

    allSections.slice(1).forEach(section => {
      const ul = section.querySelector(selector);
      if (!ul) return;

      ul.querySelectorAll('li').forEach(li => {
        const key = keyFn(li);
        if (!existingKeys.has(key)) {
          mainUl.appendChild(li.cloneNode(true));
          existingKeys.add(key);
        }
      });
    });

    Array.from(mainUl.getElementsByTagName("LI"))
        .sort((a, b) => a.textContent.localeCompare(b.textContent))
        .forEach(li => mainUl.appendChild(li));
  }

  mergeLists('.dropdown.countries ul', li => li.textContent.trim());
  mergeLists('.dropdown.states ul', li => `${li.dataset.country}-${li.dataset.state}`);
  mergeLists('.dropdown.stores ul', li => `${li.dataset.country}-${li.dataset.state}-${li.dataset.address}`);

  mergeLists('ul.store', li => li.textContent.trim());
});